export const StoreKeys = {
  USER: 'GojirafUser',
  TOKEN: 'token',
  ORDER_DATA: 'order_data',
  ORDER_ID: 'order_id',
  PAYMENT_ID: 'payment_id',
  INITIAL_QUERY_PARAMS: 'initial_query_params',
  GOJIRAF_USER_TTL: 900000,
}
